module.exports = __webpack_public_path__ + "img/gg-1.164a12c2.svg";